import { CompanyListDTO } from './company.model';
import { UserRole } from "./enums.model";

/**
 * Modello per memorizzare i dati dell'utente
 */
export class UserDTO {
  ID: string;
  Name: string;
  Surname: string;
  Email: string;
  Password: string;
  ChangedPassword: boolean;
  DisabledLastChangeDate: Date
  FK_Company: number;
  Role: UserRole;
  CanMassiveDelete: boolean;
  PolicyReaded: boolean;
  policyShopReaded: boolean;
  SurveyDone: Date;
  MyNamirialEmail: string;
  IsDarkMode: boolean;

}

export class UserListDTO {
  ID: string;
  Name: string;
  Surname: string;
  Email: string;
  FK_Company: number;
}

export class ChangePasswordDTO {
  userID: string
  oldPassword: string
  newPassword: string
}


